var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "home-container" },
        [
          _vm.isShow.header
            ? _c(
                "el-header",
                {
                  staticStyle: {
                    background: "#23262e",
                    "font-size": "0",
                    padding: "0"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "flex-direction": "row" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "200px",
                            height: "60px",
                            "font-size": "16px",
                            "line-height": "60px",
                            color: "#fff",
                            "text-align": "center"
                          },
                          on: { click: _vm.throwError }
                        },
                        [_vm._v("\n          一手 ERP\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { height: "60px", color: "white" },
                              attrs: { type: "text" },
                              on: { click: _vm.Collapse }
                            },
                            [
                              _vm.isCollapse
                                ? _c("i", {
                                    staticClass: "el-icon-d-arrow-right"
                                  })
                                : _c("i", {
                                    staticClass: "el-icon-d-arrow-left"
                                  })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "header-bar" },
                        [
                          _c(
                            "el-dropdown",
                            {
                              staticStyle: {
                                padding: "0 20px",
                                color: "#fff",
                                height: "100%",
                                "line-height": "60px",
                                cursor: "pointer"
                              },
                              attrs: { trigger: "click" },
                              on: { command: _vm.handleCommand }
                            },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.username) +
                                    "\n              "
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right"
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: { divided: "", command: "logout" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                退出登录\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "header-bar" },
                            [
                              _vm.storehouse
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "header-storehouse",
                                      staticStyle: { "line-height": "1" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          _vm.isShowDialogMobilize = true
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              所属仓库：" +
                                          _vm._s(_vm.storehouse) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    height: "60px",
                                    color: "white",
                                    "font-size": "20px"
                                  },
                                  attrs: { type: "text" },
                                  on: { click: _vm.showDownload }
                                },
                                [_c("i", { staticClass: "el-icon-download" })]
                              ),
                              _vm._v(" "),
                              _vm.testMode
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "320px",
                                        display: "flex",
                                        "align-items": "center",
                                        height: "60px",
                                        "margin-right": "12px"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            "white-space": "nowrap",
                                            color: "#fff"
                                          }
                                        },
                                        [_vm._v("测试环境：")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          ref: "qaEnvNumInput",
                                          staticClass: "input-with-prepend",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            size: "mini",
                                            type: "number",
                                            readonly: _vm.inputDisabled,
                                            placeholder: "stable不需要填写"
                                          },
                                          on: {
                                            input: _vm.handleQaEnvNumInput
                                          },
                                          model: {
                                            value: _vm.qaEnvNum,
                                            callback: function($$v) {
                                              _vm.qaEnvNum = $$v
                                            },
                                            expression: "qaEnvNum"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                slot: "prepend",
                                                placeholder: "请选择",
                                                disabled: _vm.inputDisabled
                                              },
                                              on: {
                                                change: _vm.handleQaEnvChange
                                              },
                                              slot: "prepend",
                                              model: {
                                                value: _vm.qaEnv,
                                                callback: function($$v) {
                                                  _vm.qaEnv = $$v
                                                },
                                                expression: "qaEnv"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "erp-feat-",
                                                  value: "erp-feat-"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "erp",
                                                  value: "erp"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "erp-stable",
                                                  value: "erp-stable"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.inputDisabled,
                                                expression: "inputDisabled"
                                              }
                                            ],
                                            staticClass:
                                              "el-icon-edit el-input__icon",
                                            staticStyle: { cursor: "pointer" },
                                            attrs: { slot: "suffix" },
                                            on: { click: _vm.enableEnvInput },
                                            slot: "suffix"
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.inputDisabled,
                                                expression: "!inputDisabled"
                                              }
                                            ],
                                            staticClass:
                                              "el-icon-check el-input__icon",
                                            staticStyle: { cursor: "pointer" },
                                            attrs: { slot: "suffix" },
                                            on: { click: _vm.envInputSave },
                                            slot: "suffix"
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.testMode || _vm.devMode
                                ? _c(
                                    "el-popover",
                                    {
                                      staticStyle: { "margin-right": "12px" },
                                      attrs: {
                                        placement: "bottom",
                                        width: "400"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { type: "flex" } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { flex: "1" } },
                                            [
                                              _c("el-input", {
                                                attrs: { clearable: "" },
                                                model: {
                                                  value: _vm.osHost,
                                                  callback: function($$v) {
                                                    _vm.osHost = $$v
                                                  },
                                                  expression: "osHost"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              },
                                              on: {
                                                click: _vm.handleConfirmOsHost
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  确定\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { padding: "8px" },
                                          attrs: {
                                            slot: "reference",
                                            type: "default",
                                            size: "small"
                                          },
                                          slot: "reference"
                                        },
                                        [
                                          _vm._v(
                                            "\n                os域名\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-container",
            [
              _vm.isShow.menu
                ? _c(
                    "el-aside",
                    { staticClass: "home-aside", attrs: { width: "" } },
                    [
                      _c(
                        "el-menu",
                        {
                          ref: "homeElMenu",
                          staticClass: "el-menu-vertical-demo self-menu",
                          staticStyle: { border: "0" },
                          attrs: {
                            id: "homeElMenu",
                            "background-color": "#23262E",
                            "text-color": "#fff",
                            "active-text-color": "#f13685",
                            collapse: _vm.isCollapse,
                            "default-active": _vm.defaultActive,
                            "unique-opened": ""
                          },
                          on: { select: _vm.handleSelect }
                        },
                        [
                          !_vm.isCollapse
                            ? _c(
                                "div",
                                {
                                  staticClass: "search",
                                  style: {
                                    "justify-content": _vm.isCollapse
                                      ? "center"
                                      : "flex-start"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { "font-size": "13px" },
                                    attrs: {
                                      id: "searchKey",
                                      clearable: true,
                                      type: "text",
                                      "prefix-icon": "el-icon-search",
                                      placeholder: "搜索菜单"
                                    },
                                    model: {
                                      value: _vm.searchKey,
                                      callback: function($$v) {
                                        _vm.searchKey = $$v
                                      },
                                      expression: "searchKey"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "search-kbd-wrap" },
                                    [
                                      _c("kbd", { staticClass: "search-kbd" }, [
                                        _vm._v(_vm._s(_vm.searchKeyAbdText))
                                      ]),
                                      _vm._v(" "),
                                      _c("kbd", { staticClass: "search-kbd" }, [
                                        _vm._v("K")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _c("div", { staticClass: "search-icon" }, [
                                _c("i", {
                                  staticClass: "el-icon-search",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCollapsedChange(false)
                                    }
                                  }
                                })
                              ]),
                          _vm._v(" "),
                          _vm._l(_vm.searchMenuList || _vm.menu, function(
                            pmenu
                          ) {
                            return _c(
                              "el-submenu",
                              {
                                key: pmenu.label,
                                attrs: { index: pmenu.id.toString() },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function() {
                                        return [
                                          pmenu.label == "权限管理"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-alizhanghaoquanxianguanli"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "代采管理"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-alicaigou-xianxing"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "仓储管理"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-alicangkucangchu-xianxing"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "财务管理"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-alicaiwu-xianxing"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "商家管理"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-alihezuoguanxi-xianxing"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "数据表格管理"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-alitubiao-zhuzhuangtu"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "业务监控"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-alishujukanban"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "配置管理"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-aliicon_shezhi"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "买手部管理"
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-aliquanxianshenpi"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "消息公告"
                                            ? _c("i", {
                                                staticClass: "el-icon-bell"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "售后工单"
                                            ? _c("i", {
                                                staticClass: "el-icon-tickets"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "商家消息通知"
                                            ? _c("i", {
                                                staticClass: "el-icon-message"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          pmenu.label == "商家权限管理"
                                            ? _c("i", {
                                                staticClass: "el-icon-key"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(pmenu.label))
                                          ])
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _vm._l(pmenu.children, function(cmenu) {
                                  return [
                                    cmenu.children != undefined
                                      ? _c(
                                          "el-submenu",
                                          {
                                            key:
                                              pmenu.id.toString() +
                                              "-" +
                                              cmenu.id.toString(),
                                            staticClass: "submenu2",
                                            attrs: {
                                              index: cmenu.id.toString()
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                cmenu.children != undefined
                                                  ? {
                                                      key: "title",
                                                      fn: function() {
                                                        return [
                                                          _vm._v(
                                                            _vm._s(cmenu.label)
                                                          )
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  : null
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _vm._l(cmenu.children, function(
                                              ccmenu
                                            ) {
                                              return [
                                                cmenu.children != undefined
                                                  ? _c(
                                                      "el-menu-item",
                                                      {
                                                        key: ccmenu.id.toString(),
                                                        attrs: {
                                                          index: ccmenu.link
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(ccmenu.label)
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    cmenu.children == undefined
                                      ? _c(
                                          "el-menu-item",
                                          {
                                            key: cmenu.id.toString(),
                                            attrs: { index: cmenu.link }
                                          },
                                          [_vm._v(_vm._s(cmenu.label))]
                                        )
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-main",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.$store.getters.loading,
                      expression: "$store.getters.loading"
                    }
                  ],
                  staticClass: "el-main",
                  staticStyle: { padding: "0" }
                },
                [
                  _vm.editableTabs && _vm.editableTabs.length
                    ? _c(
                        "div",
                        { staticClass: "tag-view" },
                        [
                          _c(
                            "div",
                            _vm._l(_vm.editableTabs, function(tag) {
                              return _c(
                                "el-tag",
                                {
                                  key: tag.name,
                                  staticStyle: {
                                    margin: "5px",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    effect:
                                      _vm.editableTabsValue === tag.name
                                        ? "dark"
                                        : "plain",
                                    closable: "",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openNav(tag.name)
                                    },
                                    close: function($event) {
                                      return _vm.removeTab(tag.name)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(tag.title))]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown",
                            { on: { command: _vm.handleCommand } },
                            [
                              _c("el-button", {
                                attrs: { icon: "el-icon-close", size: "small" }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "closeAllTag" } },
                                    [_vm._v("关闭全部")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "closeOthersTag" } },
                                    [_vm._v("关闭其他")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { margin: "15px" } },
                    [
                      _vm.debug
                        ? [_c("router-view", { key: _vm.$route.fullPath })]
                        : _c(
                            "keep-alive",
                            { attrs: { exclude: _vm.uncachedRouteNames } },
                            [_c("router-view", { key: _vm.$route.fullPath })],
                            1
                          )
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowDialogDownload,
            width: "80%",
            top: "20",
            "before-close": _vm.closeDownload
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("\n      下载列表\n      "),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v("(下次刷新倒计时:" + _vm._s(_vm.flashTime) + ")")
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.files, height: "500" }
            },
            [
              _c("el-table-column", {
                attrs: { fixed: "", prop: "id", label: "id", width: "50" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "title", label: "任务名", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "total_num", label: "数据总数", width: "100" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "进度", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-progress", {
                          attrs: {
                            percentage: parseInt(scope.row.progress),
                            status: scope.row.down_status == 1 ? "success" : ""
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "admin_name", label: "管理员", width: "80" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "create_time", label: "导出时间", width: "160" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "下载链接", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.canDown == 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "success", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFile(scope.row.fileurl)
                                  }
                                }
                              },
                              [_vm._v("下载")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.canDown == 0
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.filename) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.down_status == 0
                          ? _c("span", [_vm._v("导出中")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.down_status == 1
                          ? _c("span", { staticStyle: { color: "green" } }, [
                              _vm._v("\n            已完成\n          ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.down_status == 9
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("\n            错误\n          ")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                staticStyle: { color: "red" },
                attrs: { prop: "error_msg", label: "错误信息", width: "200" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.down_status == 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "danger" },
                                on: {
                                  click: function($event) {
                                    return _vm.stopTask(scope.row)
                                  }
                                }
                              },
                              [_vm._v("停止")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("DialogMobilize", {
        attrs: { "search-params": { admin_name: _vm.username } },
        model: {
          value: _vm.isShowDialogMobilize,
          callback: function($$v) {
            _vm.isShowDialogMobilize = $$v
          },
          expression: "isShowDialogMobilize"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a90ec03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a90ec03","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = null
// module chunks = 